import { PrescriptionNonDispensationRequest } from "../medical-record/prescription-non-dispensation.request";

export class SolutionNonDispesationRequest {
    public idPrescriptionSolution: number;
    public listPrescriptionNonDispensationRequest: PrescriptionNonDispensationRequest[] = [];
}